import React, { useState } from 'react';
import MessageForm from '../MessageForm/MessageForm';

const Navbar = () => {
    const [modalIsOpen, setIsOpen] = useState(false);
    const openModal = () => {
        setIsOpen(true);
    }

    const closeModal = () => {
        setIsOpen(false);
    }

    return (
        <nav className="navbar navbar-expand-lg  pt-4" id="navbar" style={{ background: "rgb(245, 245, 247)", opacity: "0.9" }}>
            <h3 className="name">Kazi <span className="font-weight-bold">Mashry</span></h3>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item ml-4">
                        <a className="nav-link" href="#home">Home <span className="sr-only">(current)</span></a>
                    </li>
                    <li className="nav-item ml-4">
                        <a className="nav-link" href="#projects">Projects</a>
                    </li>
                    {/* <li className="nav-item ml-4">
                        <a className="nav-link" href="#problemSolving">Problem Solving</a>
                    </li> */}
                    <li className="nav-item ml-4">
                        <a className="nav-link" href="#blogs">Blog Posts</a>
                    </li>
                    <li className="nav-item ml-4">
                        <a className="nav-link" href="#about">About</a>
                    </li>
                    <li className="nav-item ml-4">
                        <button type="button" className="btn btn-transparent" style={{ color: "#007bff" }} onClick={openModal}>Contact</button>
                    </li>
                    <li className="nav-item ml-4">
                        <button type="button" className="btn btn-light">
                            <a className="text-decoration-none" href="https://drive.google.com/file/d/1fMBG5_W4IFeg4qeYRuDA6jNetPqrfMYk/view" target="blank">Resume</a>
                        </button>
                    </li>
                </ul>
            </div>
            <MessageForm modalIsOpen={modalIsOpen} closeModal={closeModal} />
        </nav>
    );
};

export default Navbar;